<template>
  <div>
    <div class="option-column-container">
      <div>
        <div class="my-stock-column">
          <div class="my-stock-column-item">My Stocks</div>
          <stock-card :hotel-id="fromHotelId" large flush />
          <div class="my-stock-column-item">{{ stocksLeft }} Stocks</div>
        </div>
      </div>

      <div>
        <div class="button-column">
          <div>
            <p>Trade 2 for 1</p>
            <o-increment
              :value="stocksTraded"
              :add-disabled="!canAddTrade"
              :remove-disabled="!canRemoveTrade"
              @add="addTrade"
              @remove="removeTrade"
            />
          </div>
          <div>
            <p>Sell {{ pricePerStock | formatCurrency }} each</p>
            <o-increment
              :value="stocksSold"
              :add-disabled="!canAdd"
              :remove-disabled="!canRemoveSell"
              @add="addSell"
              @remove="removeSell"
            />
          </div>
          <div>
            <p>Keep</p>
            <o-increment
              :value="stocksKept"
              :add-disabled="!canAdd"
              :remove-disabled="!canRemoveKeep"
              @add="addKeep"
              @remove="removeKeep"
            />
          </div>
        </div>
      </div>

      <div class="result-column">
        <div class="result-column-item">
          <stock-card :hotel-id="toHotelId" large flush />
          <div class="center-text">{{ toHotelStocks }} Left</div>
        </div>
        <div class="result-column-item money">
          {{ totalSellingPrice | formatCurrency }}
        </div>
        <div class="result-column-item">
          <stock-card :hotel-id="fromHotelId" large flush />
        </div>
      </div>
    </div>

    <o-button
      @click="onDone"
      :disabled="!canClickDone"
      class="done-button"
    >
      Done
    </o-button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OButton from "@/components/OButton";
import StockCard from "@/components/StockCard";
import OIncrement from "@/components/OIncrement";
import { formatCurrency } from "@/currency-filter";
import {NS_GAME_STATE, NS_TURN_STATE} from "@/store/constants";

export default {
  name: 'MergerStockSection',

  components: {
    OIncrement,
    StockCard,
    OButton
  },

  filters: {
    formatCurrency,
  },

  data() {
    return {
      stocksLeft: 0,
      toHotelStocks: 0,
      stocksTraded: 0,
      stocksSold: 0,
      stocksKept: 0,
    }
  },

  computed: {
    ...mapGetters(NS_GAME_STATE, [
      'mergingHotelId',
      'survivingHotelId',
      'localPlayerStocks',
      'stockMoneyPerHotel',
      'stocks',
      'mergingPlayerId',
    ]),

    fromHotelId() {
      return this.mergingHotelId;
    },

    toHotelId() {
      return this.survivingHotelId;
    },

    pricePerStock() {
      return this.stockMoneyPerHotel[this.fromHotelId].price;
    },

    totalSellingPrice() {
      return this.stocksSold * this.pricePerStock;
    },

    canAdd() {
      return this.stocksLeft > 0;
    },

    canAddTrade() {
      return this.canAdd && this.toHotelStocks > 0 && this.stocksLeft >= 2;
    },

    canRemoveTrade() {
      return this.stocksTraded > 0;
    },

    canRemoveSell() {
      return this.stocksSold > 0;
    },

    canRemoveKeep() {
      return this.stocksKept > 0;
    },

    canClickDone() {
      return this.stocksLeft === 0;
    }
  },

  created() {
    this.stocksLeft = this.localPlayerStocks[this.mergingHotelId];
    this.toHotelStocks = this.stocks[this.toHotelId].quantity;
  },

  methods: {
    ...mapActions(NS_TURN_STATE, [
      'flowMergerPlayerDone',
    ]),

    addTrade() {
      this.stocksLeft -= 2;
      this.toHotelStocks -= 1;
      this.stocksTraded += 1;
    },

    removeTrade() {
      this.stocksLeft += 2;
      this.toHotelStocks += 1;
      this.stocksTraded -= 1;
    },

    addSell() {
      this.stocksLeft -= 1;
      this.stocksSold += 1;
    },

    removeSell() {
      this.stocksLeft += 1;
      this.stocksSold -= 1;
    },

    addKeep() {
      this.stocksLeft -= 1;
      this.stocksKept += 1;
    },

    removeKeep() {
      this.stocksLeft += 1;
      this.stocksKept -= 1;
    },

    onDone() {
      this.flowMergerPlayerDone({
        playerId: this.mergingPlayerId,
        fromHotelId: this.fromHotelId,
        toHotelId: this.toHotelId,
        sold: this.stocksSold,
        kept: this.stocksKept,
        traded: this.stocksTraded * 2,
      });

      this.stocksLeft = this.localPlayerStocks[this.mergingHotelId];
      this.toHotelStocks = this.stocks[this.toHotelId].quantity;
      this.stocksTraded = 0;
      this.stocksSold = 0;
      this.stocksKept = 0;
    }
  },
}
</script>

<style scoped>
.option-column-container {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.button-column {
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
}

.button-column p {
  padding-bottom: 6px;
}

/*.result-column {*/
/*  margin-top: -18px;*/
/*  margin-bottom: -18px;*/
/*}*/

/*.result-column-item {*/
/*  margin-top: 18px;*/
/*  margin-bottom: 18px;*/
/*}*/

.my-stock-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.my-stock-column-item {
  padding: 10px 0;
}

.money {
  font-family: 'Rozha One', serif;
  height: 80px;
  width: 80px;
  display: flex;
  color: #108657;
  font-size: 25px;
  font-weight: 600;
  justify-content: center;
  align-items: center;
}

.done-button {
  text-align: center;
  display: flex;
  margin: 18px auto;
  padding-left: 43px;
  padding-right: 43px;
}

.center-text {
  padding-top: 8px;
  text-align: center;
}

</style>
